import { Flyout } from "@amzn/stencil-react-components/flyout";
import { FlyoutContent } from "@amzn/stencil-react-components/flyout";
import React, { FC, useState } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";

import { HardwareOrderSupport } from "./hardware-order-support";
import { HardwareSupportOptions } from "./hardware-support-options";
import { MessageConfirmation } from "./message-confirmation";

interface HardwareSupportFlyoutProps {
  onClose: () => void;
}

type Step = "options" | "order" | "message";

export const HardwareSupportFlyout: FC<HardwareSupportFlyoutProps> = ({ onClose }) => {
  const [step, setStep] = useState<Step>("options");

  const renderStep = () => {
    switch (step) {
      case "options":
        return <HardwareSupportOptions onOrderClick={() => setStep("order")} />;
      case "order":
        return (
          <HardwareOrderSupport
            onBackClick={() => setStep("options")}
            onSendMessageClick={() => setStep("message")}
          />
        );
      case "message":
        return <MessageConfirmation />;
    }
  };

  return (
    <Flyout isOpen={true} close={onClose}>
      <FlyoutContent
        titleText={getString("hardwareSupport.hardwareSupportTitle")}
        onCloseButtonClick={onClose}
        maxWidth="600px"
      >
        {renderStep()}
      </FlyoutContent>
    </Flyout>
  );
};
